function About() {
  return (
    <div style={{ padding: '60px 40px', maxWidth: '900px', margin: '0 auto' }}>

      {/* Title */}
      <h1 style={{ color: '#1a6b3c', fontSize: '36px', marginBottom: '10px' }}>🏫 About Our School</h1>
      <p style={{ color: '#777', fontSize: '15px', marginBottom: '30px' }}>
        Established in 2010 | Panruti, Cuddalore District
      </p>

      {/* About Text */}
      <div style={{ background: 'white', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 15px rgba(0,0,0,0.07)', marginBottom: '30px', lineHeight: '1.9', color: '#444', fontSize: '17px' }}>
        <p style={{ marginBottom: '16px' }}>
          Our school is committed to providing quality education that nurtures young minds and shapes responsible citizens. We believe that education is not just about academics, but also about building character, discipline, and values.
        </p>
        <p style={{ marginBottom: '16px' }}>
          With a team of dedicated and experienced teachers, we focus on creating a supportive and engaging learning environment where every student is encouraged to explore their talents and achieve their full potential.
        </p>
        <p style={{ marginBottom: '16px' }}>
          We follow a balanced curriculum that includes academics, co-curricular activities, sports, and environmental awareness programs. Our school takes pride in promoting creativity, critical thinking, and leadership skills among students.
        </p>
        <p style={{ marginBottom: '16px' }}>
          We also emphasize moral values, respect for others, and social responsibility, helping students grow into confident and compassionate individuals.
        </p>
        <p style={{ fontWeight: 'bold', color: '#1a6b3c' }}>
          Our mission is to empower students with knowledge, skills, and values to face future challenges and contribute positively to society.
        </p>
      </div>

      {/* Principal & Chairman */}
      <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '30px' }}>
        {[
          { icon: '👩‍🏫', role: 'Principal', name: 'P. Lakshmi' },
          { icon: '👨‍💼', role: 'Chairman', name: 'P. Krishnamoorthy' },
        ].map((person, i) => (
          <div key={i} style={{
            flex: 1,
            minWidth: '200px',
            background: 'white',
            borderRadius: '12px',
            padding: '24px',
            textAlign: 'center',
            boxShadow: '0 4px 15px rgba(0,0,0,0.07)',
            borderTop: '4px solid #1a6b3c'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>{person.icon}</div>
            <div style={{ color: '#777', fontSize: '14px', marginBottom: '6px' }}>{person.role}</div>
            <div style={{ color: '#1a6b3c', fontSize: '20px', fontWeight: 'bold' }}>{person.name}</div>
          </div>
        ))}
      </div>

      {/* Stats */}
      <div style={{
        background: 'linear-gradient(135deg, #1a6b3c, #1565c0)',
        color: 'white',
        borderRadius: '12px',
        padding: '40px',
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        gap: '20px'
      }}>
        {[
          { number: '480+', label: 'Students' },
          { number: '20+', label: 'Teachers' },
          { number: '14+', label: 'Years of Excellence' },
          { number: '2010', label: 'Year Established' },
          { number: '99%', label: 'Pass Rate' },
        ].map((stat, i) => (
          <div key={i} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{stat.number}</div>
            <div style={{ fontSize: '15px', opacity: 0.9 }}>{stat.label}</div>
          </div>
        ))}
      </div>

    </div>
  );
}

export default About;